import React from "react";
import "./magnifier.scss";

const Magnifier =
    magnifierClass =>
    ({ zoomIn, zoomOut, disableOut, disableIn }) => {
        return (
            <div className={`magnifier ${magnifierClass}`}>
                <div className="magnifier__content">
                    <button type="button" className="magnifier__button" disabled={disableOut} onClick={zoomOut}>
                        −
                    </button>
                    <button type="button" className="magnifier__button" disabled={disableIn} onClick={zoomIn}>
                        +
                    </button>
                </div>
            </div>
        );
    };
export const MagnifierX = Magnifier("magnifier_x");
export const MagnifierY = Magnifier("magnifier_y");
